
export default {
  name: 'AppSlider',

  props: {
    startValue: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      left: 0,
      baseX: null,
      totalWidth: null
    }
  },

  watch: {
    left (newValue) {
      this.$emit('update', newValue)
    },
    startValue (newValue) {
      this.left = newValue
    }
  },

  mounted () {
    this.left = this.startValue
    this.init()

    window.addEventListener('resize', this.init)
  },

  destroyed () {
    window.removeEventListener('resize', this.init)
  },

  methods: {
    init () {
      this.baseX = this.$refs.slider.getBoundingClientRect().left
      this.totalWidth = this.$refs.slider.offsetWidth
    },
    calculate (x) {
      const diff = Math.abs(this.baseX - x)
      this.left = (diff / this.totalWidth) * 100
    },
    jump (event) {
      this.calculate(event.x)
    },
    startDrag () {
      window.addEventListener('mousemove', this.drag)
      window.addEventListener('mouseup', this.stopDrag)
    },
    stopDrag () {
      window.removeEventListener('mousemove', this.drag)
      window.removeEventListener('mouseup', this.stopDrag)
    },
    drag (e) {
      if (e.x <= this.baseX) {
        this.left = 0

        return
      }

      if (e.x > (this.baseX + this.totalWidth)) {
        this.left = 100

        return
      }

      this.calculate(e.x)
    }
  }
}
